<template>
  <div class="view__view view-contact">
    <div class="view__headline">
      <span class="heading beta -color-white">Wie lauten Ihre Kontaktdaten?</span>
    </div>
    <div class="view__form form">
      <div class="field__wrap">
        <div class="col">
          <TextInput identifier="email" placeholder="E-Mail (optional)"
                     :value="user.email"
                     @update="user.email = $event"></TextInput>
        </div>
      </div>
      <div class="field__wrap">
        <div class="col">
          <TextInput identifier="telephone" placeholder="Telefonnummer (optional)"
                     :value="user.telephone"
                     @update="user.telephone = $event"></TextInput>
        </div>
      </div>
    </div>
    <div class="cta-wrapper">
      <button class="-btn-beta" @click="handleSubmit"><span>Weiter zum Reklamationsgrund</span></button>
    </div>
  </div>
</template>

<script>
import TextInput from '@/components/Input/TextInput.vue';
import { useUserStore } from '@/stores/user';
import { useViewStore } from '@/stores/view';

export default {
  name: 'ContactDataEntry',
  components: { TextInput },
  methods: {
    handleSubmit() {
      this.view.update('ReclamationEntry', this.view.counter + 1);
    },
  },
  setup() {
    const user = useUserStore();
    const view = useViewStore();
    return {
      user,
      view,
    };
  },
};
</script>
